import { useEffect, useState } from 'react'
import { useRouter, useLocalSearchParams, type Href } from 'expo-router'
import { LoaderScreen } from '../app/components/LoaderScreen/LoaderScreen'
import {
  UniversalLogoutOrchestrator,
  silentAuth0Logout,
  type LogoutStatus
} from '../app/utils/thirdPartyUtils/universalLogoutOrchestrator'
import { useStore } from '../app/models'

export default function UniversalLogout() {
  const router = useRouter()
  const store = useStore()
  const params = useLocalSearchParams<{
    returnTo?: string
    redirectUri?: string
  }>()

  const [statuses, setStatuses] = useState<LogoutStatus[]>([])
  const [currentStep, setCurrentStep] = useState<'platforms' | 'auth0' | 'complete'>('platforms')

  useEffect(() => {
    // This screen is web-only
    if (typeof window === 'undefined') return

    executeUniversalLogout()
  }, [])

  async function executeUniversalLogout() {
    console.log('[UniversalLogout] Starting universal logout flow')
    console.log('[UniversalLogout] Params:', params)

    try {
      // Phase 1: Logout from all platforms via iframes
      console.log('[UniversalLogout] Phase 1: Starting platform logout')
      setCurrentStep('platforms')
      const orchestrator = new UniversalLogoutOrchestrator((newStatuses) => {
        console.log('[UniversalLogout] Status update:', newStatuses)
        setStatuses(newStatuses)
      })
      await orchestrator.executeLogout()
      console.log('[UniversalLogout] Phase 1: Platform logout complete')

      // Phase 2: Silent Auth0 logout + app session cleanup
      console.log('[UniversalLogout] Phase 2: Starting Auth0 logout')
      setCurrentStep('auth0')
      await silentAuth0Logout()
      console.log('[UniversalLogout] Phase 2: Auth0 logout complete')

      console.log('[UniversalLogout] Phase 2: Cleaning up session')
      store.session.cleanupSession()
      console.log('[UniversalLogout] Phase 2: Session cleanup complete')

      // Phase 3: Redirect
      setCurrentStep('complete')
      const redirectUrl = params.returnTo || params.redirectUri || '/'
      console.log('[UniversalLogout] Phase 3: Redirecting to:', redirectUrl)

      // Use window.location for external URLs
      if (redirectUrl.startsWith('http')) {
        console.log('[UniversalLogout] Using window.location for external URL')
        window.location.href = redirectUrl
      } else {
        console.log('[UniversalLogout] Using router.replace for internal URL')
        router.replace(redirectUrl as Href)
      }
    } catch (error) {
      console.error('[UniversalLogout] Error during logout:', error)
      // Fallback: still cleanup app session
      store.session.cleanupSession()
      router.replace('/' as Href)
    }
  }

  return <LoaderScreen />
}
